import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as windowService from "../services/windowService";

const saveModule = (action$) =>
    action$.pipe(
        ofType(actionTypes.SAVE_MODULE),
        switchMap(() => {
            return [
                {
                    type: actionTypes.CONNECT_DEFAULT_SERVER
                }
            ];
        })
    );

const changeModule = (action$) =>
    action$.pipe(
        ofType(actionTypes.CHANGE_MODULE),
        switchMap(() => {
            windowService.restartRedlike();

            return [];
        })
    );

const changeSoftwareType = (action$) =>
    action$.pipe(
        ofType(actionTypes.CHANGE_SOFTWARE_TYPE),
        switchMap(() => {
            return [
                {
                    type: actionTypes.DATABASE_CHANGE
                }
            ];
        })
    );

export default [saveModule, changeModule, changeSoftwareType];
